module.exports = __webpack_public_path__ + "static/media/satisfied.be95538d.svg";